import React, { useState } from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { observer } from 'src/utils/mobx-react';
import {  PersonalDetailsTabState, PersonalDetailsTabStateInner } from 'src/components/CustomersBar/CustomerTab/PersonalDetailsTab/PersonalDetailsTab.state';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { Select } from 'src/domains/layouts/shared/formComponents/Select/components/Select';
import { PersonalDetailsCustomerID, PersonalDetailsRowContainer, PersonalDetailsSuccessMessage, PersonalDetailsUniversePrefix, PersonalDetailsUniverseWrapper } from 'src/components/CustomersBar/CustomerTab/PersonalDetailsTab/PersonalDetailsTab.style';
import { StaffAccountBasicDataType } from 'src/AppState/sdk/staff';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { DateInputNew } from 'src/domains/layouts/shared/formComponents/dateInput/DateInputNew';
import { InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { CountryDropdownNew } from 'src/components/CountryDropdown/CountryDropdownNew';
import { countriesList, mobilePrefixes } from 'src/components/CountryDropdown/CountryDropdownNew.state';

interface PersonalDetailsTabProps {
    customerId: number,
}

interface PersonalDetailsTabInnerProps {
    customerId: number,
    userData: StaffAccountBasicDataType
}

export const PersonalDetailsTabInner = observer('PersonalDetailsTabInner', ({ customerId, userData }: PersonalDetailsTabInnerProps): JSX.Element | null => {
    const { sdkStaff, reduxBackofficeUserState: {universePrefix}, configState: {config: { externalId, personalId, cpfProperties, fullNameProperties, userTitleOptional}} } = useAppStateContext();
    const [ state ] = useState(() => new PersonalDetailsTabStateInner(sdkStaff, customerId, userData, userTitleOptional));

    return (
        <div>
            <div className='row personal-details-form'>
                <div className='col-6'>
                    <PersonalDetailsRowContainer>
                        <PersonalDetailsUniverseWrapper>
                            <div className='col-6'>
                                <InputLabel>
                                Account ID
                                </InputLabel>
                                <PersonalDetailsUniverseWrapper>
                                    <PersonalDetailsUniversePrefix>{universePrefix}</PersonalDetailsUniversePrefix>
                                    <PersonalDetailsCustomerID data-test='personal-details-account-id'>{customerId}</PersonalDetailsCustomerID>
                                </PersonalDetailsUniverseWrapper>
                            </div>
                            {cpfProperties === true ? <div className='col-6'>
                                <Input formInputState={state.cpfInput} placeholder='CPF' label='CPF' dataTest='cpf' disabled={true}/>
                            </div> : null}
                            {externalId ? (
                                <div className='col-6'>
                                    <Input formInputState={state.externalIdInput} placeholder='External ID' label='External ID'/>
                                </div>
                            ) : null}
                        </PersonalDetailsUniverseWrapper>
                    </PersonalDetailsRowContainer>
                    <PersonalDetailsRowContainer>
                        <div className='col-6'>
                            <Input formInputState={state.telebetingIdInput} placeholder='Telebetting ID' label='Telebetting ID' dataTest='personal-details-telebetting-id'/>
                        </div>
                        <div className='col-6'>
                            <Input formInputState={state.telebetingPasswordInput} placeholder='Telebetting Password' label='Telebetting Password' dataTest='personal-details-telebetting-password'/>
                        </div>
                    </PersonalDetailsRowContainer>
                    <div className='row'>
                        <div className='col-4'>
                            <Select label='Title' stateValue={state.titleInput} selectOptions={state.titleList()} dataTest='personal-details-title'/>
                        </div>
                        <div className='col-8'>
                            <Input formInputState={state.firstNameInput} placeholder='First name' label='First name' dataTest='personal-details-first-name'/>
                        </div>
                    </div>
                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <Input formInputState={state.surnameInput} placeholder='Surname' label='Surname' dataTest='personal-details-surname'/>
                        </div>
                    </PersonalDetailsRowContainer>
                    {fullNameProperties === true ? (
                        <PersonalDetailsRowContainer>
                            <div className='col-12'>
                                <Input formInputState={state.fullNameInput} placeholder='Full name' label='Full name' dataTest='personal-details-fullName'/>
                            </div>
                        </PersonalDetailsRowContainer>
                    ) : null}
                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <DateInputNew stateValue={state.birthDayInput} placeholder='birthDay' label='Date of birth' selected={state.birthDayInput.value} dataTest='personal-details-date-of-birth'/>
                        </div>
                    </PersonalDetailsRowContainer>
                    {personalId ? (
                        <PersonalDetailsRowContainer>
                            <div className='col-12'>
                                <Input formInputState={state.personalIdInput} placeholder='Personal ID' label='Personal ID' dataTest='personal-details-personal-id'/>
                            </div>
                        </PersonalDetailsRowContainer>
                    ) : null }
                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <Input formInputState={state.bankAccountNumberInput} placeholder='Bank account number' label='Bank account number'/>
                        </div>
                    </PersonalDetailsRowContainer>
                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <Input formInputState={state.sortCodeInput} placeholder='Sort code' label='Sort code'/>
                        </div>
                    </PersonalDetailsRowContainer>
                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <Input formInputState={state.emailInput} placeholder='E-mail' label='E-mail' dataTest='personal-details-e-mail'/>
                        </div>
                    </PersonalDetailsRowContainer>
                </div>

                <div className='col-6'>
                    <div className='row'>
                        <div className='col-4' data-test='mobile-prefix'>
                            <CountryDropdownNew
                                label='Mobile Prefix'
                                options={ mobilePrefixes }
                                stateValue={ state.phonePrefixInput }
                            />
                        </div>
                        <div className='col-8'>
                            <div className='col-12'>
                                <Input formInputState={state.phoneNumberInput} placeholder='Mobile Phone' label='Mobile Phone' dataTest='personal-details-mobile-number'/>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-4'>
                            <CountryDropdownNew
                                label='Landline prefix'
                                options={ mobilePrefixes }
                                stateValue={ state.landlinePrefixInput }
                            />
                        </div>
                        <div className='col-8'>
                            <div className='col-12'>
                                <Input formInputState={state.landLineNumberInput} placeholder='Landline number' label='Landline number'/>
                            </div>
                        </div>
                    </div>
                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <Input formInputState={state.address1Input} placeholder='Address line 1' label='Address line 1' dataTest='personal-details-address-line-1'/>
                        </div>
                    </PersonalDetailsRowContainer>
                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <Input formInputState={state.address2Input} placeholder='Address line 2' label='Address line 2' dataTest='personal-details-address-line-2'/>
                        </div>
                    </PersonalDetailsRowContainer>
                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <Input formInputState={state.townInput} placeholder='Town / City' label='Town / City' dataTest='personal-details-town-city'/>
                        </div>
                    </PersonalDetailsRowContainer>
                    <PersonalDetailsRowContainer >
                        <div className='col-12'>
                            <Input formInputState={state.countyInput} placeholder='County' label='County' dataTest='personal-details-county'/>
                        </div>
                    </PersonalDetailsRowContainer>
                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <Input formInputState={state.postCodeInput} placeholder='Postcode' label='Postcode' dataTest='personal-details-postcode'/>
                        </div>
                    </PersonalDetailsRowContainer>
                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <Select label='Country' stateValue={state.countryInput} selectOptions={countriesList} dataTest='personal-details-country'/>
                        </div>
                    </PersonalDetailsRowContainer>

                    { state.isUpdatedSuccesfully ? (
                        <PersonalDetailsRowContainer>
                            <div className='col-12'>
                                <PersonalDetailsSuccessMessage data-test='personal-details-success-message'>Updated successfully</PersonalDetailsSuccessMessage>
                            </div>
                        </PersonalDetailsRowContainer>
                    ) : null}

                    <PersonalDetailsRowContainer>
                        <div className='col-12'>
                            <Button onClick={state.submitUpdate} dataTest='personal-details-update-button'>Update Account</Button>
                        </div>
                    </PersonalDetailsRowContainer>
                </div>
            </div>
        </div>
    );
});

export const PersonalDetailsTab = observer('PersonalDetailsTab', ({ customerId }: PersonalDetailsTabProps): JSX.Element | null => {
    const { models } = useAppStateContext();
    const [ state ] = useState(() => new PersonalDetailsTabState(models, customerId));
    const userData = state.getBasicData;

    if (userData === null) {
        return null;
    }

    return (
        <PersonalDetailsTabInner customerId={customerId} userData={userData}/>
    );
});
